import * as React from 'react';
import { Plus } from 'lucide-react';
import { Button } from 'shared-portal-components-v2';

import { classNames } from '@/utils/classNames.utils';

interface ExternalInvitationAddMoreRowsButtonProps {
  onClick: () => void;
  className?: string;
}

function ExternalInvitationAddMoreRowsButton(props: ExternalInvitationAddMoreRowsButtonProps): React.JSX.Element {
  const { onClick, className } = props;

  return (
    <Button
      type="button"
      variant="outline"
      onClick={onClick}
       className={classNames(
        'h-10 px-4 py-2 w-full',
        className
      )}
    >
      <Plus className="h-5 w-5" />
      Add more rows
    </Button>
  );
}

ExternalInvitationAddMoreRowsButton.displayName = 'ExternalInvitationAddMoreRowsButton';

export default ExternalInvitationAddMoreRowsButton;
